import {useNavigation} from '@react-navigation/native';
import {Button, Card, Layout, Modal, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet} from 'react-native';
import {DRAWER_ROUTES} from '../../../../../navigation/constants';
import {isLandscape, px, wp} from '../../../../../utils';
import {TitleRow} from '../../../../components';

const NewNotifModal = ({visible, onClose}) => {
  const navigation = useNavigation();

  return (
    <Modal
      visible={visible}
      backdropStyle={styles.backdrop}
      onBackdropPress={onClose}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <TitleRow
            title="Announcement"
            type="primary"
            iconName="close-circle-outline"
            onIconClick={onClose}
            containerStyle={styles.title}
          />
          <Text style={styles.text}>
            {'You have new announcement,\nplease check!'}
          </Text>
          <Button
            style={styles.button}
            onPress={() => {
              setTimeout(() => {
                navigation.navigate(DRAWER_ROUTES.inbox.path);
              }, 100);
              onClose();
            }}>
            {'View Announcement'}
          </Button>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    width: isLandscape() ? wp(30) : wp(90),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  title: {
    width: '100%',
  },
  text: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '600',
    marginTop: isLandscape() ? px(83) : px(33),
    marginHorizontal: 12,
  },
  button: {
    marginTop: isLandscape() ? px(75) : px(41),
    marginBottom: px(24),
    marginHorizontal: 32,
  },
});

export default NewNotifModal;
